import React from 'react';
import './_commonjsHelpers-df867233.js';
import { P as PropTypes } from './index-6a8f8095.js';
import styled from 'styled-components';
import { _ as _taggedTemplateLiteral, a as _objectWithoutProperties } from './_rollupPluginBabelHelpers-b3c9b1cd.js';

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  flex-direction: row;\n\n  > * {\n    width: auto;\n  }\n\n  > *:first-child {\n    border-bottom-right-radius: 0;\n    border-top-right-radius: 0;\n\n    border-right: none;\n  }\n\n  > *:last-child {\n    border-bottom-left-radius: 0;\n    border-top-left-radius: 0;\n  }\n\n  > *:not(:first-child):not(:last-child) {\n    border-radius: 0;\n\n    border-right: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var StyledHorizontalInputGroup = styled.div(_templateObject());

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  flex-direction: column;\n\n  > * {\n    height: auto;\n  }\n\n  > *:first-child {\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n\n    border-bottom: none;\n  }\n\n  > *:last-child {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n  }\n\n  > *:not(:first-child):not(:last-child) {\n    border-radius: 0;\n\n    border-bottom: none;\n  }\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledVerticalInputGroup = styled.div(_templateObject$1());

function _templateObject$2() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
/**
 * A Simple InputGroup.
 *
 */

var InputGroup = function InputGroup(_ref) {
  var children = _ref.children,
      vertical = _ref.vertical,
      rest = _objectWithoutProperties(_ref, ["children", "vertical"]);

  var StyleComponent = vertical ? StyledVerticalInputGroup : StyledHorizontalInputGroup;
  return React.createElement(StyleComponent, rest, children);
};

InputGroup.defaultProps = {
  vertical: false
};
InputGroup.propTypes = {
  /**
   * The cols to use as header for the table.
   */
  children: PropTypes.any.isRequired,

  /**
   * Are the Inputs displayed vertically or not.
   */
  vertical: PropTypes.bool
};
/** @component */

var index = styled(InputGroup)(_templateObject$2());

export default index;
